import { DialogBackdrop } from '@headlessui/react';
import { FC } from 'react';
import { PulseLoader } from 'react-spinners';
import { getColors } from '@/tailwind/get-colors';

export const DrawerLoader: FC = () => (
  <div className="absolute bottom-0 left-0 right-0 top-0">
    <DialogBackdrop
      transition
      className="drawer-dialog-backdrop absolute bottom-0 left-0 right-0 top-0 bg-gray-500 bg-opacity-25 transition-opacity duration-100 ease-in-out data-[closed]:opacity-0"
    />

    <div className="absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2">
      <PulseLoader color={getColors().secondary} />
    </div>
  </div>
);
